import {useState, useEffect, useContext} from "react";
import CalculationSheet from "./calculationSheet/CalculationSheet";
import { adjustContent, observer } from "../methods/contentDistributionHelpers";
import PageList from "./pageList/PageList";
import { Route, Routes } from "react-router-dom";
import {ValuationDataContext} from "../contextProviders/ValuationDataProvider";
import useValutationData from "../hooks/useValutationData";

const Valuation = ({ authenticated, refs }) => {
  const [editable, setEditable] = useState(authenticated);
    const {valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate, isLoading} = useValutationData();
  return (
    <main>
      <Routes>
        <Route
          path="wycena"
          element={<PageList refs={refs} editable={editable} valuationData={valuationData} setValuationData={setValuationData} calculateSensitivityAnalysis={calculateSensitivityAnalysis}
                             calculateNPVtoDiscountRate={calculateNPVtoDiscountRate}
          />}
        />
        <Route
          path="arkusz"
          element={<CalculationSheet editable={editable} valuationData={valuationData} setValuationData={setValuationData} calculateSensitivityAnalysis={calculateSensitivityAnalysis}
                                     calculateNPVtoDiscountRate={calculateNPVtoDiscountRate}

          />}
        />
      </Routes>
    </main>
  );
};

export default Valuation;
